import { render, staticRenderFns } from "./MasterDataDisplay.vue?vue&type=template&id=f7ab2a50"
import script from "./MasterDataDisplay.vue?vue&type=script&lang=js"
export * from "./MasterDataDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports